import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import de from './locales/de/translation.json';
import fr from './locales/fr/translation.json';
import es from './locales/es/translation.json';
import enLegal from './locales/en/legal.json';
import deLegal from './locales/de/legal.json';
import frLegal from './locales/fr/legal.json';
import esLegal from './locales/es/legal.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeName: 'English' },
  { code: 'de', label: 'German', nativeName: 'Deutsch' },
  { code: 'fr', label: 'French', nativeName: 'Français' },
  { code: 'es', label: 'Spanish', nativeName: 'Español' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en, legal: enLegal },
      de: { translation: de, legal: deLegal },
      fr: { translation: fr, legal: frLegal },
      es: { translation: es, legal: esLegal },
    },
    // `translation` stays the default so existing t('nav.signIn') calls are unchanged;
    // the long-form legal documents live in their own namespace.
    ns: ['translation', 'legal'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'careumba_lang',
    },
  });

/**
 * Keep the <html lang> attribute, the tab title and the description/social meta tags
 * in the visitor's language. index.html carries the English versions for crawlers
 * that do not run scripts.
 */
function applyDocumentLanguage(lng: string) {
  document.documentElement.setAttribute('lang', lng);
  document.title = i18n.t('meta.title');
  const description = i18n.t('meta.description');
  for (const selector of ['meta[name="description"]', 'meta[property="og:description"]']) {
    document.querySelector(selector)?.setAttribute('content', description);
  }
  document.querySelector('meta[property="og:title"]')?.setAttribute('content', i18n.t('meta.title'));
}

i18n.on('languageChanged', applyDocumentLanguage);
applyDocumentLanguage(i18n.resolvedLanguage || 'en');

export default i18n;
